/**
 * System Forms - Speech Therapist (קלינאות תקשורת)
 *
 * Read-only forms specific to speech therapy clinics.
 *
 * TAG REFERENCE (from DEVELOPER_GUIDE.md Section 4.14.1):
 *   Patient field:    <span class="patient-field-placeholder" data-field="FIELD_KEY" contenteditable="false">{LABEL}</span>
 *   Free text:        <span class="free-text-placeholder" data-label="LABEL" contenteditable="false">[טקסט חופשי: LABEL]</span>
 *   Client signature: <div class="signature-placeholder" contenteditable="false"><div class="signature-line"></div><span class="signature-label">חתימת לקוח</span></div>
 *   Signature date:   <span class="signature-date-placeholder" contenteditable="false">[תאריך חתימה]</span>
 *
 *   Available patient fields: firstName, lastName, fullName, phone, idNumber, email, birthDate, address, city,
 *                              clinicName, parent1Name, parent1Phone, parent2Name, parent2Phone,
 *                              emergencyContactName, emergencyContactRelation, emergencyContactPhone
 */

const tag = (field, label) =>
  `<span class="patient-field-placeholder" data-field="${field}" contenteditable="false">{${label}}</span>`;

const freeText = (label) =>
  `<span class="free-text-placeholder" data-label="${label}" contenteditable="false">[טקסט חופשי: ${label}]</span>`;

const clientSignature =
  `<div class="signature-placeholder" contenteditable="false"><div class="signature-line"></div><span class="signature-label">חתימת לקוח</span></div>`;

const signatureDate =
  `<span class="signature-date-placeholder" contenteditable="false">[תאריך חתימה]</span>`;

export const speechTherapistForms = [
  {
    id: "sys_form_st_initial_assessment",
    name: "טופס אבחון ראשוני - קלינאות תקשורת",
    content:
      `<h2 style="text-align:center;">טופס אבחון ראשוני – קלינאות תקשורת</h2>` +
      `<p style="text-align:center;">${tag("clinicName", "שם הקליניקה")}</p>` +
      `<hr/>` +

      `<h3>1. פרטי המטופל/ת</h3>` +
      `<p><strong>שם פרטי:</strong> ${tag("firstName", "שם פרטי")}&nbsp;&nbsp;&nbsp;<strong>שם משפחה:</strong> ${tag("lastName", "שם משפחה")}</p>` +
      `<p><strong>ת.ז.:</strong> ${tag("idNumber", "תעודת זהות")}&nbsp;&nbsp;&nbsp;<strong>תאריך לידה:</strong> ${tag("birthDate", "תאריך לידה")}</p>` +
      `<p><strong>כתובת:</strong> ${tag("address", "כתובת")}</p>` +
      `<p><strong>טלפון:</strong> ${tag("phone", "טלפון")}&nbsp;&nbsp;&nbsp;<strong>אימייל:</strong> ${tag("email", "אימייל")}</p>` +
      `<p><strong>הורה / אפוטרופוס:</strong> ${tag("parent1Name", "הורה 1 - שם")}&nbsp;&nbsp;&nbsp;<strong>טלפון:</strong> ${tag("parent1Phone", "הורה 1 - טלפון")}</p>` +
      `<p><strong>מסגרת חינוכית:</strong> ${freeText("מסגרת חינוכית")}&nbsp;&nbsp;&nbsp;<strong>כיתה / גן:</strong> ${freeText("כיתה / גן")}</p>` +
      `<hr/>` +

      `<h3>2. סיבת הפנייה</h3>` +
      `<p><strong>גורם מפנה:</strong> ${freeText("גורם מפנה")}</p>` +
      `<p><strong>תלונה עיקרית:</strong></p>` +
      `<p>${freeText("תלונה עיקרית")}</p>` +
      `<hr/>` +

      `<h3>3. רקע התפתחותי</h3>` +
      `<p><strong>הריון ולידה:</strong> ${freeText("הריון ולידה (תקין / סיבוכים)")}</p>` +
      `<p><strong>אבני דרך מוטוריות:</strong> ישיבה: ${freeText("גיל ישיבה")}&nbsp;&nbsp;הליכה: ${freeText("גיל הליכה")}</p>` +
      `<p><strong>מילים ראשונות:</strong> ${freeText("גיל מילים ראשונות")}&nbsp;&nbsp;<strong>משפטים:</strong> ${freeText("גיל משפטים")}</p>` +
      `<p><strong>שפות בבית:</strong> ${freeText("שפות בבית")}</p>` +
      `<p><strong>בעיות שמיעה:</strong> ${freeText("בעיות שמיעה (כן/לא, פירוט)")}</p>` +
      `<p><strong>בדיקת שמיעה אחרונה:</strong> ${freeText("תאריך בדיקת שמיעה אחרונה")}</p>` +
      `<hr/>` +

      `<h3>4. היסטוריה טיפולית</h3>` +
      `<p><strong>טיפולים קודמים:</strong> ${freeText("טיפולים קודמים (סוג, משך, מסגרת)")}</p>` +
      `<p><strong>אבחנות קיימות:</strong> ${freeText("אבחנות קיימות")}</p>` +
      `<hr/>` +

      `<h3>5. ממצאי האבחון</h3>` +

      `<h4>5.1 שפה רצפטיבית (הבנה)</h4>` +
      `<p>${freeText("ממצאי שפה רצפטיבית")}</p>` +

      `<h4>5.2 שפה אקספרסיבית (הבעה)</h4>` +
      `<p>${freeText("ממצאי שפה אקספרסיבית")}</p>` +

      `<h4>5.3 היגוי ופונולוגיה</h4>` +
      `<p>${freeText("ממצאי היגוי ופונולוגיה")}</p>` +

      `<h4>5.4 שטף דיבור</h4>` +
      `<p>${freeText("ממצאי שטף דיבור")}</p>` +

      `<h4>5.5 קול</h4>` +
      `<p>${freeText("ממצאי קול")}</p>` +

      `<h4>5.6 תפקודי פה (אורו-מוטורי)</h4>` +
      `<p>${freeText("ממצאי תפקודי פה")}</p>` +
      `<hr/>` +

      `<h3>6. סיכום והמלצות</h3>` +
      `<p><strong>אבחנה:</strong></p>` +
      `<p>${freeText("אבחנה")}</p>` +
      `<p><strong>המלצות טיפוליות:</strong></p>` +
      `<p>${freeText("המלצות טיפוליות")}</p>` +
      `<hr/>` +

      `<p><strong>חתימת הלקוח/ה:</strong></p>` +
      `<p>${clientSignature}</p>` +
      `<p><strong>תאריך:</strong> ${signatureDate}</p>`,
    isSystem: true,
    clinicTypes: ["speech_therapist"],
    category: "assessment",
  },
];
